import { ContentCard } from "@msuite/ui/content-card";
import { TextInput } from "@msuite/ui/form";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { CalculationFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

export function CalculationFormMeta() {
	/** Hooks */
	const methods = useFormContext<CalculationFormSchema>();
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			title={t("general.information")}
			icon={icon("Info")}
			variant="plain"
		>
			<TextInput
				control={methods.control}
				name="name"
				label={t("general.name")}
				placeholder={t("placeholders.calculation_name")}
				isRequired
				helperText={t("calculations.find_a_name_to_identify_your_calculation_later")}
				debounceMs={300}
			/>
		</ContentCard>
	);
}
